<template>
  <b-container>
    <b-row v-loading="loading">
      <div style="margin: 15px 0">
        <router-link :to="{ name : 'AdminsCreate' }"><b-button variant="dark" size="sm">Admin Ekle</b-button></router-link>
      </div>
      <b-col cols="12" style="margin-bottom:10px">
        <b-card header="Filtreleme" header-tag="header" class="filter-panel">
          <b-row>
              <b-col cols="1">
                  <b-form-group label="ID">
                    <b-form-input type="number" size="sm" v-model="filter.id" placeholder="ID"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Admin ismi">
                    <b-form-input size="sm" v-model="filter.name" placeholder="İsim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Admin maili">
                    <b-form-input type="email" size="sm" v-model="filter.mail" placeholder="Mail arama" ></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Firma">
                    <b-form-select size="sm" v-model="filter.client_id" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="item.id" v-for="(item,key) in clients" :key="key">{{ item.title }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Durum">
                  <b-form-select size="sm" v-model="filter.status" class="form-control mb-3 form-control-sm">
                    <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                    <b-form-select-option :value="1">Aktif</b-form-select-option>
                    <b-form-select-option :value="0">Pasif</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group style="margin-top:30px">
                  <b-button variant="primary" @click="filterBtn()" style="font-size:12px; margin-right:10px" size="sm">Filtrele</b-button>
                  <b-button variant="danger" @click="clearBtn()" style="font-size:12px" size="sm">Temizle</b-button>
                </b-form-group>
              </b-col>
          </b-row>
        </b-card>
      </b-col>
      <div>
        <div class="table-responsive">
          <table style="table-layout:fixed; font-size:14px;vertical-align: middle;" class="table table-striped table-bordered" v-if="!_.isEmpty(data)">
          <thead>
            <tr>
              <th style="width:40px">ID</th>
              <th>İsim</th>
              <th >Email</th>
              <th>Firma</th>
              <th>Oluşturma Tarihi</th>
              <th>Son Görülme Tarihi</th>
              <th>Durumu</th>
              <th style="width:150px">Detaylar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,key) in data" :key="key">
              <td>{{ item.id }}</td>
              <td>{{ item.name }} {{ item.surname }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.client.title }}</td>
              <td>{{ $moment(item.created_at).format('MM.DD.YYYY h:mm:ss') }}</td>
              <td>{{ $moment(item.last_seen_at).format('MM.DD.YYYY h:mm:ss') }}</td>
              <td>{{ item.status == "1" ? 'Aktif' : 'Pasif' }}</td>
              <td>
                <router-link :to="{ name: 'AdminsDetail', params: { id : item.id } }"><b-button variant="primary" size="sm">Detaylar</b-button></router-link>
              </td>
            </tr>
          </tbody>
          <div class="block pagination">
            <el-pagination
                v-if="filter.pageTotal > 0"
                @size-change="handleSizeChange"
                @current-change="fetch"
                :current-page.sync="filter.page"
                :page-sizes="sizes"
                :page-size="filter.size"
                layout="sizes, prev, pager, next"
                :total="filter.pageTotal"
            ></el-pagination>
          </div> 
        </table>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'AdminsList',
    data(){
      return{
        sizes: [10, 20, 50, 100],
        loading: false,
        filter:{
          name:null,
          client_id:null,
          id:null,
          mail:null,
          status:null,
          pageTotal: 0,
          size: 10,
          page: 1,
          types: []
        },
        clients:[],
        data:[]
      }
    },
    watch:{
        "filter.types": function(val) {
          this.fetch(1, this.filter.size);
        },
    },
    created(){
      this.fetch();
      this.fetchClients();
    },
    methods:{
      filterBtn(){
        this.fetch(1, this.filter.size);
      },
      clearBtn(){
        this.filter.name = null;
        this.filter.client_id = null;
        this.filter.mail = null;
        this.filter.id = null;
        this.filter.status = null;
        this.fetch(1, this.filter.size);
      },
      handleSizeChange(value){
        this.filter.size = value;
        this.fetch();
      },
      fetchClients(){
        axios.get('/list/clients')
        .then((response) => {
            this.clients = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      fetch(page = 1, size = null, silent = false){
        this.filter.page = page;

        if (!_.isNull(size)) 
        {
            this.filter.size = size;
        }
        if(!silent) this.loading = true;
        axios.get('/admin',{params: this.filter })
        .then((response) => {
          this.data = response.data.data;
          this.filter.pageTotal  	= response.data.data.total;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
    }
  }
</script>